const TermsAndConditions = () => {
    return (
        <div className="p-3">
             <h1>Terms & Conditions for Fernandes Driver</h1>
            <p><strong>Effective Date:</strong> 6th of December 2024</p>
            <p>Welcome to Fernandes Driver! This document outlines the terms and conditions (the “Terms”) that govern your use of the Fernandes Driver mobile game. By downloading, installing, or using Fernandes Driver, you agree to these Terms. Please read them carefully.</p>

            <h2>1. Eligibility</h2>
            <p>1.1. Only individuals aged 13 years or older are permitted to download and play Fernandes Driver. This restriction complies with the global responsible marketing guidelines of The Coca-Cola Company.</p>
            <p>1.2. By downloading the game, you confirm that you meet this age requirement.</p>

            <h2>2. Ownership and Copyright</h2>
            <p>2.1. Fernandes Driver is owned and operated by Fernandes Concern Beheer N.V.</p>
            <p>2.2. All copyrights, trademarks, and other intellectual property rights in and to the game, including its design, music tracks, graphics, text, and software, are owned by Fernandes Concern Beheer N.V.</p>
            <p>2.3. Unauthorized use, reproduction, or distribution of any content from Fernandes Driver is strictly prohibited and may result in legal action.</p>

            <h2>3. System Requirements</h2>
            <p>3.1. Fernandes Driver is available for Android and iOS devices and can be downloaded through the Google Play Store and Apple App Store.</p>
            <p>3.2. To ensure optimal performance, the following device specifications are required:</p>
            <ul>
                <li>Operating System: Android 10 or higher, iOS 13 or higher</li>
                <li>RAM Storage: At least 6 GB of available RAM for smooth gameplay</li>
            </ul>
            <p>3.3. Devices with older operating systems or lower specifications may experience difficulties in downloading or running the game, and certain features may not function correctly. Fernandes Concern Beheer N.V. is not responsible for such performance issues.</p>

            <h2>4. Availability</h2>
            <p>4.1. Fernandes Driver is exclusively available to users with Android and iOS devices registered in Suriname.</p>
            <p>4.2. Users living outside Suriname, or users with Google Play or Apple App Store accounts registered in other countries, will not be able to access or download the game.</p>

            <h2>5. Pricing & Advertisements</h2>
            <p>5.1. Fernandes Driver is entirely free to download and play.</p>
            <p>5.2. The game does not contain any in-game advertisements that interfere with the playing experience or interrupt the flow of the game.</p>
            <p>5.3. Fernandes Driver contains in-game advertisements in the form of dynamic product placements, where Fernandes products and brands naturally appear within the game environment (billboards, items, etc.). </p>

            <h2>6. Privacy</h2>
            <p>6.1. Fernandes Concern Beheer N.V. values your privacy. By using Fernandes Driver, you agree to the collection and use of personally and non-personally identifiable data for the purpose of improving the game experience. Personally identifiable data may include your email address. For details, please refer to our Privacy Policy.</p>

            <h2>7. Prohibited Conduct</h2>
            <p>7.1. You agree not to:</p>
            <ul>
                <li>Use the game for any unlawful or unauthorized purpose.</li>
                <li>Attempt to reverse-engineer, decompile, or modify any part of the game.</li>
                <li>Exploit bugs, errors, or glitches to gain an unfair advantage.</li>
            </ul>

            <h2>8. Disclaimers and Limitation of Liability</h2>
            <p>8.1. Fernandes Driver is provided "as is," and Fernandes Concern Beheer N.V. makes no warranties, express or implied, regarding the performance, functionality, or availability of the game.</p>
            <p>8.2. Fernandes Concern Beheer N.V. shall not be liable for:</p>
            <ul>
                <li>Any technical issues arising from using devices that do not meet the recommended specifications.</li>
                <li>Losses or damages resulting from the use or inability to use the game.</li>
            </ul>

            <h2>9. Modifications and Updates</h2>
            <p>9.1. Fernandes Concern Beheer N.V. reserves the right to modify or update these Terms at any time. Any changes will be communicated through an update or notice within the game.</p>
            <p>9.2. Continued use of the game after such updates signifies your acceptance of the revised Terms.</p>

            <h2>10. Governing Law and Jurisdiction</h2>
            <p>10.1. These Terms shall be governed by and construed in accordance with the laws of Suriname.</p>
            <p>10.2. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts of Suriname.</p>

            <h2>11. Contact Information</h2>
            <p>For questions or concerns regarding these Terms or the game, please contact us at: <a href="mailto:Fernandes.driver@fernandes.sr">Fernandes.driver@fernandes.sr</a></p>

            <p>By downloading and using Fernandes Driver, you acknowledge that you have read, understood, and agree to abide by these Terms. Thank you for playing!</p>



        </div>
    );
};


export default TermsAndConditions;
